import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    root: {
        width: '600px',
        padding: ({ smallPadding }) => (smallPadding ? 20 : '40px 40px 20px'),
        minWidth: '520px',
        boxSizing: 'border-box',
    },
    title: {
        fontWeight: 'bold',
        lineHeight: '32px',
        marginTop: ({ preTitle }) => (preTitle ? 0 : '-30px'),
        fontSize: '26px',
        marginBottom: '25px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '15px',
    },
    message: {
        paddingTop: '15px',
        fontSize: '15px',
    },
    actionFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '20px',
    },
    leftSide: {},
    rightSide: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    actionPanelButton: {
        minWidth: '120px',
        padding: '10px 30px',
        marginRight: '20px',
        '&:last-of-type': {
            marginRight: '0',
        },
    },
    preTitle: {
        fontSize: '11px',
        fontWeight: '400',
        textTransform: 'uppercase',
        lineHeight: '20px',
        letterSpacing: '1.5%',
    },
}));
